<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Editar pergunta"
    type-modal="puzzle_edit_question_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="save()">
        <d-form-row class="form-group">
          <d-col cols="12">
            <label>Pergunta:</label>
            <textarea
              v-model="question.question"
              class="form-control"
              :class="{ 'is-invalid': submitted && !question.question }"
            />
            <d-form-invalid-feedback>
              Nome é obrigatório
            </d-form-invalid-feedback>
          </d-col>
        </d-form-row>

        <d-form-row class="form-group">
          <d-col cols="12">
            <label>Nível:</label>
            <custom-select
              v-model="levelOption"
              :options="LEVEL_OPTIONS"
              trackBy="slug"
              label="label"
              placeholder="Selecione o nível..."
              @change="option => (question.level = option.slug)"
              :class="{ 'is-invalid': submitted && !question.level }"
            >
              <template #option="{ option }">
                <i :class="option.color" class="fas fa-circle mr-2" />
                {{ option.label }}
              </template>
            </custom-select>
            <d-form-invalid-feedback>
              Nível é obrigatório
            </d-form-invalid-feedback>
          </d-col>
        </d-form-row>
      </d-form>
      <div class="small text-warning text-center">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        <span class="text-dark">
          As alterações serão refletidas no banco de palavras e não apenas neste
          puzzle.
        </span>
      </div>
    </div>

    <div slot="actions" class="modal-content__control">
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary float-right"
      >
        Salvar
      </d-button>
      <d-button
        type="button"
        @click="close()"
        class="btn btn-sm btn-secondary mr-4 float-right"
      >
        Cancelar
      </d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import PuzzleService from '_services/rest/modules/puzzle';
import CustomSelect from '_shared/CustomSelect.vue';
import { cloneDeep, LEVEL_OPTIONS, getLevelOption } from '_utils';
import {
  _PUZZLE_EDIT_QUESTION_OPTION_,
  _PUZZLE_EDIT_QUESTION_UPDATED_,
} from '../PuzzleModel';

export default {
  name: 'puzzle-edit-question-modal',
  components: {
    ModalTemplate,
    CustomSelect,
  },
  data() {
    return {
      submitted: false,
      question: {
        id: null,
        question: null,
        level: null,
      },
      levelOption: null,
      LEVEL_OPTIONS,
    };
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert']),
    close() {
      this.setToggle({ type: 'puzzle_edit_question_modal', bool: false });
    },
    save() {
      this.submitted = true;

      if (!this.validate()) {
        return;
      }

      PuzzleService.editQuestion(this.question).then(() => {
        this.activeAlert({
          message: 'Pergunta atualizada com sucesso!',
          theme: 'success',
        });
        Events.$emit(_PUZZLE_EDIT_QUESTION_UPDATED_, this.question);
        this.close();
      });

      this.submitted = false;
    },
    validate() {
      if (!this.question.question || !this.question.level) {
        return false;
      }
      return true;
    },
  },
  destroyed() {
    Events.$off(_PUZZLE_EDIT_QUESTION_OPTION_);
  },
  mounted() {
    Events.$on(_PUZZLE_EDIT_QUESTION_OPTION_, question => {
      this.question = cloneDeep(question);
      this.levelOption = getLevelOption(question.level);
    });
  },
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 8000;
  &-content__control {
    width: 100%;
  }
}
</style>
